
export interface CategoryInterface {
    id: number;
    name: string;
    description?: string;
}

export class Category implements CategoryInterface {
    public id: number;
    public name: string;
    public description?: string;

    constructor(
        id: number,
        name: string,
        description?: string
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
    }

    static fromJson(json: any): Category {
        return new Category(
            json.id,
            json.name,
            json.description
        );
    }
}